<template>
    <div style="padding: 30px 0;">
        <div v-html="content"></div>
    </div>
</template>

<script>
    export default {
        props: {
            content: {
                type: String,
                default: ""
            }
        },
        data() {
            return {

            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/RichText.vue